<template>
    <v-dialog v-model="dialog" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">{{$store.getters.getModalTitle}}</v-card-title>
          <v-card-text>{{$store.getters.getModalContext}}</v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" text @click="doSomething()">Yes</v-btn>
            <v-btn color="primary" text @click="toClose()">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>


<script>

export default {
  name: 'confirmWindow',
  components: {    
  },
  props: {
  },
  data () {
    return {
        dialog:true
    }
  },
  methods: {
    doSomething(){
      let data = this.$store.getters.getModalContent
      var dv = new ArrayBuffer(1);
      dv.value=data.value
      this.$store.dispatch('WriteCharValue',{cuuid:data.cuuid,value:dv,message:data.message})
      this.$store.commit('closeModal')
    },
    toClose: function () {
      this.$store.commit('closeModal')
    }
  }
}
</script>